import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/Approutes";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./styles/mui-styles";
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
